/* eslint-disable */
export default {
  schedule: 'Planifier une réunion',
  prompt:
    'Veuillez autoriser RingCentral à accéder aux renseignements de votre compte.',
  saveAsDefault: 'Enregistrer par défaut',
  launchMeeting: 'Lancer la réunion',
} as const;

// @key: @#@"schedule"@#@ @source: @#@"Schedule Meeting"@#@
// @key: @#@"prompt"@#@ @source: @#@"Please authorize RingCentral to access your account information."@#@
// @key: @#@"saveAsDefault"@#@ @source: @#@"Save as default"@#@
// @key: @#@"launchMeeting"@#@ @source: @#@"Launch Meeting"@#@
